import TranslucencyMask from "components/common/TranslucencyMask";
import { useEffect, useState } from "react";
import Layout from "../components/base/Layout";
import ProjectList from "../components/biz/ProjectList";
import GuideQuickTips from "./project/editor/guide/GuideQuickTips";

export default function Index() {
  

  const [isStartGuide, setIsStartGuide] = useState<boolean>(false);

  const finish = () => {
      setIsStartGuide(false);
      localStorage.setItem('GUIDE-HOME', "1");
  }

  useEffect(() => {
      if(!localStorage.getItem('GUIDE-HOME')){
          setIsStartGuide(true)
      }
  },[])

  return (
    <Layout>
      <ProjectList />

      { isStartGuide && 
        <TranslucencyMask className="z-[10009]">
          <GuideQuickTips onCancel={finish} />
        </TranslucencyMask>
      }
    </Layout>
  );
}
